import { Box, Button, Container, useMediaQuery } from '@mui/material';
import React from 'react';
import theme from '../../theme';
import Text from './Text';
import AppModal from './AppModal';

const styles = {
  subContent: {
    background: '#B7B5D8',
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(10),
    marginTop: theme.spacing(5),
  },
  button: {
    width: theme.spacing(35),
    borderRadius: theme.spacing(5),
    background: '#4B429F',
    marginTop: theme.spacing(3),
  },
};

interface Props {
  label: string;
}

const SubContent: React.FC<Props> = ({ label }) => {
  const [openModal, setOpenModal] = React.useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box style={styles.subContent}>
      <Container>
        <Text color="#FFFFFFF" bold size="big">
          {`Got a ${label} Question?`}
        </Text>
        <Text>
          Ask it on app and get answer from other DIYers. Get inspired, Learn it
          and make it!
        </Text>
        <Button
          variant="contained"
          sx={styles.button}
          onClick={() =>
            isMobile
              ? (window.location.href = 'https://renomate.app/mobileapp')
              : setOpenModal(true)
          }
        >
          <Text size="small">Download Renomate app</Text>
        </Button>
      </Container>

      <AppModal show={openModal} onClose={() => setOpenModal(false)} />
    </Box>
  );
};

export default SubContent;
